export default __webpack_public_path__ + "static/media/pointer.21dec08a.svg";